import createCache from '@emotion/cache';

/*
  We need this to prevent hydration errors when using MUI components
 */
export default function createEmotionCache() {
  return createCache({ key: 'css' });
}
